/**
 * Automotive panel widget registrations.
 * @see docs/repo-modularity.md
 */
import './climate';
import './navigation';
import './media';
import './alerts';
import './camera';
import './ambient';
